export default "__VITE_ASSET__Ch0Tq4eR__"